import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect } from 'react';

import Header from '@components/common/Header/Header';
import TableEmptyRowExtended from '@components/common/TableEmptyRowExtended/TableEmptyRowExtended';
import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';

import useTranslation from '@hooks/useTranslation';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import ManageTranslationsTable from './components/ManageTranslationsTable/ManageTranslationsTable';
import {
  selectManageTranslationsSearchValue,
  useManageTranslationsActions,
} from './store/useManageTranslationsStore';
import style from './style.module.scss';

const ManageTranslations = () => {
  const { trackPageView } = useMatomo();
  const { t } = useTranslation();

  const locationSelectValue = selectAppLocationSelectValue();
  const searchValue = selectManageTranslationsSearchValue();

  const { setManageTranslationsSearchValue } = useManageTranslationsActions();

  const selectedLocation = locationSelectValue.id !== 'all' && locationSelectValue.level_name !== 'group';

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <>
      <Header
        title={t('Manage Translations')}
        showFacilitySelect={true}
        showLogo={true}
        extraInfo={
          selectedLocation ? (
            <FilterSearch
              value={searchValue}
              onChange={setManageTranslationsSearchValue}
              variant="header-search"
              placeholder={t('Start to type...')}
            />
          ) : undefined
        }
      />
      <div className={style.manageTranslations}>
        {selectedLocation ? (
          <ManageTranslationsTable />
        ) : (
          <table className={style.tableBodyRowEmpty}>
            <tbody>
              <TableEmptyRowExtended text={t('Please select a facility to manage the translations')} />
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default ManageTranslations;
